import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.5 0C6.10218 0 5.72064 0.158035 5.43934 0.43934C5.15804 0.720644 5 1.10217 5 1.5V5H1.5C1.10217 5 0.720644 5.15804 0.43934 5.43934C0.158035 5.72064 0 6.10218 0 6.5V7.5C0 7.89782 0.158035 8.27936 0.43934 8.56066C0.720644 8.84196 1.10217 9 1.5 9H5V12.5C5 12.8978 5.15804 13.2794 5.43934 13.5607C5.72064 13.842 6.10217 14 6.5 14H7.5C7.89783 14 8.27936 13.842 8.56066 13.5607C8.84196 13.2794 9 12.8978 9 12.5V9H12.5C12.8978 9 13.2794 8.84196 13.5607 8.56066C13.842 8.27936 14 7.89783 14 7.5V6.5C14 6.10217 13.842 5.72064 13.5607 5.43934C13.2794 5.15804 12.8978 5 12.5 5H9V1.5C9 1.10217 8.84196 0.720644 8.56066 0.43934C8.27936 0.158035 7.89782 0 7.5 0H6.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }